<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Select Annexure & Discipline</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="closeDialog" aria-label="Close dialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="py-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-autocomplete
            v-model="selectedAnnexure"
            :items="annexures"
            label="Annexure"
            item-text="description"
            item-value="code"
            :rules="[(v) => !!v || 'Annexure is required']"
            outlined
            dense
            required
            aria-label="Select Annexure"
          />
          <v-autocomplete
            v-model="selectedDiscipline"
            :items="disciplines"
            label="Discipline"
            item-text="description"
            item-value="discipline"
            :rules="[(v) => !!v || 'Discipline is required']"
            outlined
            dense
            required
            aria-label="Select Discipline"
            class="mt-4"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" :disabled="!valid" @click="submitForm">
          Save Selection
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AnnextAndDisciplineDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    annexures: {
      type: Array,
      default: () => [],
    },
    disciplines: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: this.value,
      selectedAnnexure: null,
      selectedDiscipline: null,
      valid: false,
    };
  },
  watch: {
    value(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$emit("resetAnnexAndDisciplineDialog", false);
    },
    submitForm() {
      if (this.$refs.form.validate()) {
        this.$emit("submit", {
          annexture: this.selectedAnnexure,
          discipline: this.selectedDiscipline,
        });
        this.closeDialog();
      }
    },
  },
};
</script>

<style scoped>
.v-card-text {
  min-width: 300px;
}
</style>
